// Shared common UI texts – i18n manifest (veřejný kontrakt pro composition)

import type { SliceI18nManifest } from '@/shared/lib/vsa';
import cs from './locales/cs.json';
import en from './locales/en.json';

const NS = 'common';

export const commonI18nManifest: SliceI18nManifest = {
  owner: 'shared/common',
  namespaces: [NS],
  resources: {
    cs: {
      [NS]: cs,
    },
    en: {
      [NS]: en,
    },
  },
};
